/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  console.log('Custom JS - wren-digital.com');

  // Fade product background color
  const bg = document.querySelector(".product__background");
  const productSection = document.querySelector(".product-single");

  if (!bg || !productSection) return;

  function updateOpacity() {
    const fadeDistance = productSection.offsetHeight;
    const scrollTop = window.scrollY;

    const opacity = 1 - Math.min(scrollTop / fadeDistance, 1);
    bg.style.opacity = opacity;

    requestAnimationFrame(updateOpacity);
  }

  requestAnimationFrame(updateOpacity);





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
